<template>
  <iframe
    src="/chat/?origin=https://chatgpt-worker.entrack-plataforma.workers.dev"
    style="width:100%;height:100%;border:none"
  ></iframe>
</template>

<script>
export default {
  name: 'Chat'
}
</script>

<style scoped>
iframe {
  border-width: 0;
}
</style>
